import * as React from "react"
import { type CategoryType } from "@digits-graphql/frontend/graphql-bearer"

export const AnalysisCategoryTypesContext = React.createContext<CategoryType[]>([])

export function useAnalysisCategoryTypes() {
  return React.useContext(AnalysisCategoryTypesContext)
}
